import { NgModule }             from "@angular/core";
import { RouterModule, Routes, PreloadAllModules } from "@angular/router";
import { WarningComponent }     from "./pages/general/warning/warning.component";

const routes: Routes = [
	/*
		{path: 'blackboard/cup', component: BlackboardCupComponent},
		{path: 'blackboard/menu', component: BlackboardMenuComponent},
		{path: 'blackboard/paying', component: BlackboardPayingComponent},
		{path: 'blackboard/serving', component: BlackboardServingComponent},
		{path: 'blackboard/warning', component: BlackboardWarningComponent},

		{path: 'dallmayr/menu', component: DallmayrMenuComponent},
		{path: 'dallmayr/options', component: DallmayrOptionsComponent},
		{path: 'dallmayr/serving', component: DallmayrServingComponent},
		{path: 'dallmayr/warning', component: DallmayrWarningComponent},

		{path: 'dunkin/cup', component: DunkinCupComponent},
		{path: 'dunkin/menu', component: DunkinMenuComponent},
		{path: 'dunkin/paying', component: DunkinPayingComponent},
		{path: 'dunkin/serving', component: DunkinServingComponent},
		{path: 'dunkin/warning', component: DunkinWarningComponent},

		{path: 'tur/menu', component: TurMenuComponent},
		{path: 'tur/paying', component: TurPayingComponent},
		{path: 'tur/cup', component: TurCupComponent},
		{path: 'tur/serving', component: TurServingComponent},
		{path: 'tur/warning', component: TurWarningComponent},
		{path: 'tur/options', component: TurOptionsComponent},

		{path: 'tur-2/menu', component: Tur2MenuComponent},
		{path: 'tur-2/paying', component: Tur2PayingComponent},
		{path: 'tur-2/cup', component: Tur2CupComponent},
		{path: 'tur-2/serving', component: Tur2ServingComponent},
		{path: 'tur-2/warning', component: Tur2WarningComponent},
		{path: 'tur-2/options', component: Tur2OptionsComponent},

		{path: 'aha/menu', component: AhaMenuComponent},
		{path: 'aha/paying', component: AhaPayingComponent},
		{path: 'aha/cup', component: AhaCupComponent},
		{path: 'aha/serving', component: AhaServingComponent},
		{path: 'aha/warning', component: AhaWarningComponent},
		{path: 'aha/options', component: AhaOptionsComponent},

		{path: 'junge/menu', component: JungeMenuComponent},
		{path: 'junge/paying', component: JungePayingComponent},
		{path: 'junge/cup', component: JungeCupComponent},
		{path: 'junge/serving', component: JungeServingComponent},
		{path: 'junge/warning', component: JungeWarningComponent},
		{path: 'junge/options', component: JungeOptionsComponent},
		*/
	{path: 'general/warning', component: WarningComponent},
	{path: '', redirectTo: '/general/warning', pathMatch: 'full'}

];

@NgModule({
	imports: [RouterModule.forRoot(routes,{preloadingStrategy: PreloadAllModules, useHash: true})],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
